import { render, staticRenderFns } from "./CourseBox.vue?vue&type=template&id=4bf01824&"
import script from "./CourseBox.vue?vue&type=script&lang=js&"
export * from "./CourseBox.vue?vue&type=script&lang=js&"
import style0 from "./CourseBox.vue?vue&type=style&index=0&id=4bf01824&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports